export enum RegistrationSectionStatus {
  Inactive = 1,
  Active = 2,
  PendingByAdmin = 3,
  Rejected = 4,
  Finished = 5,
}
